import {
  baseServiceInvoiceSchema,
  ServiceInvoiceType,
} from "@redotech/redo-billing-common/service-invoice";
import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getFinalizedInvoicesForProduct = {
  name: "getFinalizedInvoicesForProduct" as const,
  input: z.object({ product: createEnum(SubscriptionProduct) }),
  output: z.array(
    baseServiceInvoiceSchema.extend({ kind: createEnum(ServiceInvoiceType) }),
  ),
};
